import { GlobalEvents, globalEvents } from "../../../utils/globalevents"
import { wasmModule } from "../wasm/wasmModule"

export interface IIPRData {
  stage: number
  value: any
}

export interface IIPRActualData {
  stage: number
  value: any
  actualIPRValue: any
  isActive: 0 | 1
}

export type ReportIPRData = Record<number, IIPRData[]>
export type ReportIPRActualData = Record<number, IIPRActualData[]>

class IprModule {
  private isOpen = false
  private stageIndexForShow = 0

  setIPRVisibility(isVisible, stageIndexForShow: number) {
    if (!wasmModule.isFinishedOpencase) return
    this.isOpen = isVisible
    this.stageIndexForShow = stageIndexForShow
    wasmModule.statusController.DisplayArchIPR(
      wasmModule.statusController.GetCurrentDiplayArch(),
      this.isOpen,
      this.stageIndexForShow,
    )
  }
  updateIPRVisibility() {
    if (this.isOpen)
      wasmModule.statusController.DisplayArchIPR(
        wasmModule.statusController.GetCurrentDiplayArch(),
        this.isOpen,
        this.stageIndexForShow,
      )
  }
  getIPRReport(getHisReport: boolean = false): ReportIPRData {
    const iprReport: ReportIPRData = {}

    const newIpr = wasmModule.statusController.GetStagesIPRReport(getHisReport)

    for (let i = 0; i < newIpr.size(); i++) {
      const iprs = newIpr.get(i)
      const toothId = Number(iprs.toothId)
      const iprData: IIPRData[] = []

      if (!Number.isInteger(toothId) || toothId <= 0) continue

      for (let j = 0; j < iprs.valVec.size(); j++) {
        const ipr = iprs.valVec.get(j)
        const stage = ipr.stepNum
        const value = ipr.value

        if (!value || Number.parseFloat(value) == 0) continue

        iprData.push({
          stage,
          value,
        })
        // console.log("ysss🚀 ~ file: iprModule.ts:44 ~ ipr:", ipr);
      }
      iprReport[toothId] = iprData
    }
    return iprReport
  }

  setActualIPRValue(IPRValuesStr: string): boolean {
    if (!wasmModule.isFinishedOpencase) return false
    return wasmModule.statusController.SetActualIPRValue(IPRValuesStr)
  }

  getActualIPRValue(): ReportIPRActualData {
    const result: ReportIPRActualData = {}
    if (!wasmModule.isFinishedOpencase) return result

    const newIprStr = wasmModule.statusController.GetActualIPRValue()
    try {
      const arr = JSON.parse(newIprStr)

      if (!Array.isArray(arr)) return result

      arr.forEach((item: any) => {
        const toothId = Number(item.toothId)
        if (
          !Number.isInteger(toothId) ||
          toothId <= 0 ||
          !Array.isArray(item.steps)
        ) {
          return
        }

        const stepData = item.steps
          .filter((step: any) => step && step.stepIndex != null)
          .map((step: any) => ({
            stage: step.stepIndex,
            value: step.value,
            actualIPRValue: step.actualIPRValue,
            isActive: step.isActive as 0 | 1,
          }))

        result[toothId] = stepData
      })
    } catch (e) {
      console.error("getActualIPRValue: JSON parse failed", e)
    }
    return result
  }

  setIPRMessage(IPRMessage: string): boolean {
    if (!wasmModule.isFinishedOpencase) return false
    return wasmModule.statusController.SetIPRMessage(IPRMessage)
  }

  getIPRMessage(): string {
    if (!wasmModule.isFinishedOpencase) return ""
    return wasmModule.statusController.GetIPRMessage()
  }

  clearActualIPRValueByStepIndex(stepIndex: number) {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.statusController.ClearActualIPRValueByStepIndex(stepIndex)
  }
}

export const iprModule = new IprModule()

globalEvents.on(GlobalEvents.VIEW_SWITCH_TYPE, (type: string) => {
  console.log("updateIPRVisibility......", type)
  iprModule.updateIPRVisibility()
})
